import { Editor } from '@monaco-editor/react';
import { debounce } from 'lodash';

export function MonacoPythonEditor(props: { script: string, onChange?: (value: string| undefined) => void, height?: string, readOnly?: boolean }) {
  const { script, onChange, height = '30vh', readOnly = false } = props;
  return (
    <Editor
      height={height}
      defaultLanguage="python"
      defaultValue={script}
      options={{
        minimap: { enabled: false },
        fontSize: 14,
        scrollBeyondLastLine: false,
        automaticLayout: true,
        wordWrap: 'on',
        renderWhitespace: 'selection',
        tabSize: 2,
        insertSpaces: true,
        lineNumbers: 'on',
        roundedSelection: false,
        cursorStyle: 'line',
        readOnly,
      }}
      theme="vs-light"
      onChange={debounce((value) => onChange?.(value), 300)}
    />
  );
}
